<template>
  <el-card
    :body-style="{ padding: '0px', width, position: 'relative' }"
    class="we-cards"
    :style="{ width }"
    shadow="hover">
    <el-checkbox
      v-if="showCheckbox"
      class="card-checkbox"
      :value="info.checked"></el-checkbox>
    <el-image
      :style="{ width, height }"
      :src="info.image"
      fit="cover"></el-image>
    <div class="card-info">
      <p class="title">{{ info.title }}</p>
      <p
        v-if="info.remark && showRemark"
        class="remark">{{ info.remark }}</p>
      <slot></slot>
    </div>
  </el-card>
</template>
<script>
export default {
  name: 'ContentCard',
  components: {},
  props: {
    info: Object,
    showCheckbox: Boolean,
    showRemark: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '140px'
    },
    height: {
      type: String,
      default: '140px'
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  methods: {}
}
</script>
<style lang="stylus">
.we-cards {
  position: relative;
  overflow: visible;
  cursor: pointer;
  z-index: 11;
  margin: 5px;
  display: inline-block;
  vertical-align: top;

  .card-checkbox {
    position: absolute;
    right: -4px;
    top: -4px;
    line-height: 1;
    margin-right: 0;

    .el-checkbox__inner {
      border-radius: 50%;
    }
  }

  .card-info {
    padding: 5px;

    .title {
      font-size: 14px;
      margin-bottom: 6px;
      overflow: hidden;
      text-align: justify;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .remark {
      position: relative;
      font-size: 12px;
      line-height: 16px;
      overflow: hidden;
      color: #999;
      text-align: justify;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
